export default "<p>\n  settings works!\n</p>\n"